<script>
  import Footer from './footer/footer.svelte';
</script>

<style>
  #app {
    background: #fff;
    margin: 0 auto;
    padding: 20px 30px;
  }

  h1 {
    font-size: 20px;
    margin-bottom: 30px;
  }

  img {
    height: auto;
    max-width: 100%;
  }
</style>

<template lang="pug" src="./app.pug"></template>
